<div class="gallery_lfp justified-gallery" ref="imageEditorGallery">    
    <a v-for="item in items" class="gallery-item imageItem image-item gallery-item" :key="item.id" >
        <div class="actions">
            <drag class="drag" :transfer-data="{type: 'local_image', id:item.id}">
                <appAwesomeIcon icon="arrows-alt" useClass="fa fa-arrows" />
                <div slot="image" class="drag-image" :style="{width:'100px', height:'100px', backgroundImage: 'url(' + item.url + ')', backgroundSize: 'contain', backgroundPosition: 'top center', backgroundRepeat: 'no-repeat'}">
				   
			    </div>
            </drag>
            <div v-on:click="deleteImageHandler(item.id)">
                <appAwesomeIcon v-if="!hideDelete" icon="trash-alt"   useClass="fa fa-trash-o" />
            </div>
        </div>
        <div class="animation-container">
            <div class='loader-animation'>
                <div v-for="time in animationTimes "></div>
            </div>
        </div>
        <img class="galleryImageItem image-item gallery-item" :src="item.url">
    </a>
</div>


